import { useState } from 'react';
import Intention from '../modal/Intention';
import Method from '../modal/Method';
import Resource from '../modal/Resource';

function Header() {
	const [intentionOpen, setIntentionOpen] = useState(false);
	const [methodOpen, setMethodOpen] = useState(false);
	const [resourceOpen, setResourceOpen] = useState(false);

	const onClickRefresh = () => {
		window.location.reload();
	};

	return (
		<div className="header">
			<button type="button" className="headerTit" onClick={onClickRefresh}>
				지역경제 활력도가 높은 지역은 어디?
			</button>

			<div className="headerBtn">
				<button onClick={(e) => setIntentionOpen(true)}>
					<img src="img/headerIcon01.png" alt="icon" />
					기획의도
				</button>
				<button onClick={(e) => setMethodOpen(true)}>
					<img src="img/headerIcon01.png" alt="icon" />
					분석방법
				</button>
				<button onClick={(e) => setResourceOpen(true)}>
					<img src="img/headerIcon02.png" alt="icon" />
					데이터 출처
				</button>
			</div>
			<Intention open={intentionOpen} setOpen={setIntentionOpen} />
			<Method open={methodOpen} setOpen={setMethodOpen} />
			<Resource open={resourceOpen} setOpen={setResourceOpen} />
		</div>
	);
}

export default Header;
